import { Row } from 'shared/components/other';

export const convertToTableRows = <T extends { id: string | number }>(data: T[]): Row<T>[] =>
  data.map((x) => ({
    data: x,
    rowId: String(x.id),
    children: null,
  }));
